import React, { useEffect, useState, useRef } from 'react';
import Banner1 from '../../assets/herobanner/HeroBanner1.webp';
import Banner2 from '../../assets/herobanner/HeroBanner2.webp';
import Banner3 from '../../assets/herobanner/HeroBanner3.webp';
import BookNowModal from '../common/BookNowModal';

const images = [Banner1, Banner2, Banner3];
const overlayTexts = [
  ['Unforgettable Trips,', 'Just a Click', 'Away'],
  ['Where Every Click', 'Takes You Closer to', 'Paradise'],
  ['Your Perfect', 'Gateway Just A Click', 'Away'],
];

function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false); // Added state for modal
  const sliderRef = useRef(null);
  const isTransitioning = useRef(false);

  // Extend arrays for seamless looping
  const extendedImages = [...images, images[0]];
  const extendedTexts = [...overlayTexts, overlayTexts[0]];

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
      isTransitioning.current = true;
    }, 3000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;

    const handleTransitionEnd = () => {
      if (currentIndex === extendedImages.length - 1) {
        isTransitioning.current = false;
        slider.style.transition = 'none';
        setCurrentIndex(0);
        slider.style.transform = `translateX(0%)`;
        slider.offsetHeight; // force reflow
        slider.style.transition = 'transform 1000ms ease-in-out';
      }
    };

    slider.addEventListener('transitionend', handleTransitionEnd);
    return () => slider.removeEventListener('transitionend', handleTransitionEnd);
  }, [currentIndex, extendedImages.length]);

  return (
    <div className='herosection relative w-full overflow-hidden'>
      <div
        ref={sliderRef}
        className='flex transition-transform duration-1000 ease-in-out'
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {extendedImages.map((img, index) => (
          <div
            key={index}
            className='relative h-[350px] w-full flex-shrink-0 bg-gray-200 sm:h-full md:h-full lg:h-full'
          >
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              className='h-full w-full object-cover'
            />

            {extendedTexts[index] && Array.isArray(extendedTexts[index]) && (
              <div className='absolute bottom-4 left-4 top-[auto] -translate-y-0 transform space-y-2  text-left text-white sm:bottom-auto  sm:top-[60%] sm:-translate-y-1/2 sm:space-y-3 sm:p-6 md:left-20 md:space-y-4'>
                {extendedTexts[index].map((line, i) => (
                  <p
                    key={i}
                    className='bg-gradient-to-r from-[#495BFF] to-[#55E6A5] bg-clip-text text-[14px] font-bold leading-[1.1] text-transparent sm:text-3xl sm:leading-[1.2] md:text-[36px] md:leading-[1.1]'
                  >
                    {line}
                  </p>
                ))}

                <button
                  onClick={handleOpenModal}
                  className='relative inline-flex h-[34px] w-[140px] items-center justify-center rounded-[6px] bg-gradient-to-r from-[#495BFF] to-[#55E6A5] p-[1px] transition-all duration-500 hover:from-[#55E6A5] hover:to-[#495BFF] sm:h-[40px] sm:w-[170px] md:h-[46px] md:w-[200px]'
                >
                  <span className='flex h-full w-full items-center justify-center rounded-lg bg-transparent text-[13px] font-bold leading-tight text-white sm:text-[15px] md:text-[16px]'>
                    Plan Your Trip Today
                  </span>
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Book Now Modal */}
      <BookNowModal
        open={modalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
}

export default HeroSection;
